import * as React from "react";
import "./MainHeader.scss";
import { MainMenu } from 'dw-main-menu';
import { IMainMenuProps } from 'dw-main-menu/dist/components/main-menu/main-menu';
import { useAuth } from "react-oidc-context";
import jwt_decode from 'jwt-decode';
import { useConfig } from "../../contexts/configContext";

const MainHeader = () => {
    const { user, isAuthenticated } = useAuth();
    const { marketingAndSalesTool: { myAccountLink, myBusinessLink } } = useConfig();
    const [state, setState] = React.useState({} as IMainMenuProps);

    React.useEffect(() => {
        setState({
            isAdp: !!isAdp(),
            isLoggedIn: isAuthenticated,
            myAccountLink: myAccountLink,
            myBusinessLink: myBusinessLink
        })
    }, [user, myAccountLink, myBusinessLink]);

    const isAdp = () => {
        let decodedToken;
        if (user?.id_token) {
            decodedToken = jwt_decode(user?.access_token)
            return decodedToken["Company Type"] === "ADP" || decodedToken["Profile_BusinessType"] === "ADP";
        }

        return false;
    }

    return (
        <MainMenu {...state} />
    );
}

export default MainHeader;
